import type { FC, MouseEvent, TouchEvent } from 'react';
import type { Point } from '@/types';

/** Size of the center dot in pixels */
const DOT_SIZE = 14;

export interface CenterDotProps {
  /** Center point of the clock */
  center: Point;
  /** Whether the dot is being dragged */
  isDragging: boolean;
  /** Called when drag starts */
  onDragStart: () => void;
}

/**
 * The center dot of the clock.
 * Rendered as a white circle at the clock's center point.
 * Supports dragging to reposition the clock center.
 */
export const CenterDot: FC<CenterDotProps> = ({
  center,
  isDragging,
  onDragStart,
}) => {
  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation(); // Prevent boundary drawing
    onDragStart();
  };

  const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    e.stopPropagation(); // Prevent boundary drawing
    onDragStart();
  };

  return (
    <div
      className="center-dot"
      style={{
        position: 'absolute',
        left: center.x,
        top: center.y,
        width: DOT_SIZE,
        height: DOT_SIZE,
        backgroundColor: '#ffffff',
        borderRadius: '50%',
        transform: 'translate(-50%, -50%)',
        cursor: isDragging ? 'grabbing' : 'grab',
        pointerEvents: 'auto',
        touchAction: 'none',
        zIndex: 10,
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    />
  );
};
